export const MAKESWIFT_SITE_VERSION_COOKIE = 'makeswift-site-version'

export const SearchParams = {
  PreviewToken: 'makeswift-preview-token',
} as const
